const PHRASING_CORRECTIONS = [
  {
    pattern: /מי (יאכל|ילך|יבוא|ישב|יהיה) ב(סופר ?בול|super ?bowl)/i,
    suggestions: [
      "מי ינצח בסופר בול?",
      "מי יזכה ב-MVP של הסופר בול?",
      "איזו קבוצה תנצח בסופר בול?",
    ],
  },
  {
    pattern: /(who will|who's going to) (eat|go|sit|be at|come to) .*(super ?bowl)/i,
    suggestions: [
      "Who will win the Super Bowl?",
      "Who will win the Super Bowl MVP?",
      "Which team will win the Super Bowl?",
    ],
  },
  {
    pattern: /(who will|who's going to) (ween|winn|wn|wen|whine|wine) .*(super ?bowl|championship|final|game|match)/i,
    suggestions: [
      "Who will win the Super Bowl?",
    ],
    type: 'spelling',
  },
  {
    pattern: /(bitcoin|btc) .*(go|move|do|happen|change)/i,
    suggestions: [
      "Will Bitcoin reach $100K by end of this year?",
      "Will Bitcoin hit a new all-time high this quarter?",
      "Will Bitcoin price be above $80K by end of month?",
    ],
  },
  {
    pattern: /(ביטקוין|btc) .*(ילך|יעשה|ישתנה|יעלה|יקרה)/i,
    suggestions: [
      "?האם ביטקוין יגיע ל-100K דולר השנה",
      "?האם ביטקוין ישבור שיא חדש הרבעון הזה",
      "?האם מחיר הביטקוין יעלה מעל 80K עד סוף החודש",
    ],
  },
  {
    pattern: /(who|מי) .*(win|ינצח|יזכה) .*(election|בחירות)/i,
    suggestions: [
      "Who will win the next presidential election?",
      "Which party will win the majority in the next election?",
    ],
  },
  {
    pattern: /(will|is) .*(ai|gpt|openai|claude|gemini) .*(do|make|change|happen|come|release|launch)/i,
    suggestions: [
      "Will OpenAI release GPT-5 by end of this year?",
      "Will an AI model score above 90% on the LMSYS leaderboard this quarter?",
      "Will AI-generated content be regulated by the EU this year?",
    ],
  },
  {
    pattern: /(מי|who) .*(יאכל|ילך|ישב|יבוא) .*(משחק|game|match|גמר|final)/i,
    suggestions: [
      "מי ינצח במשחק הגמר?",
      "איזו קבוצה תעלה לגמר?",
      "Who will win the championship final?",
    ],
  },
  {
    pattern: /(who will|who's gonna) .*(get|have|take|do) .*(nba|mvp)/i,
    suggestions: [
      "Who will win the NBA MVP this season?",
      "Which team will win the NBA Finals?",
    ],
  },
  {
    pattern: /(who|מי) .*(get|take|have|יקבל|יאכל) .*(grammy|oscar|אוסקר|גראמי)/i,
    suggestions: [
      "Who will win the Grammy for Album of the Year?",
      "Which film will win Best Picture at the Oscars?",
    ],
  },
  {
    pattern: /\bwil\b.{0,5}\bit\b.{0,5}\brain\b/i,
    suggestions: [
      "Will it rain tomorrow?",
    ],
    type: 'spelling',
  },
  {
    pattern: /^(what will happen|מה יקרה) (with|עם|ל|to|in) /i,
    suggestions: [],
  },
  {
    pattern: /(will|is|does) .*(crypto|cryptocurrency) .*(crash|moon|pump|dump|die|boom)/i,
    suggestions: [
      "Will the total crypto market cap exceed $3T by end of this year?",
      "Will Bitcoin dominance drop below 40% this quarter?",
      "Will Ethereum price be above $5,000 by end of year?",
    ],
  },
  {
    pattern: /^what('s| is| will)? (gonna |going to )?(happen|be) (next|soon|later)/i,
    suggestions: [],
  },
  {
    pattern: /(will|is) .*(stock ?market|s&p|nasdaq|dow) .*(go|crash|rise|fall|drop|boom)/i,
    suggestions: [
      "Will the S&P 500 close above 6,000 by end of this year?",
      "Will NASDAQ hit a new all-time high this quarter?",
      "Will there be a 10%+ market correction this year?",
    ],
  },
  {
    pattern: /(will|is) it (going to )?(be )?(hot|cold|warm|cool|nice|bad) /i,
    suggestions: [
      "Will the temperature exceed 100\u00B0F in your city this summer?",
      "Will there be a major hurricane in the Atlantic this season?",
    ],
  },
];

const KNOWN_WORDS = [
  'the', 'and', 'for', 'are', 'but', 'not', 'you', 'all', 'can', 'had',
  'her', 'was', 'one', 'our', 'out', 'who', 'win', 'has', 'how', 'its',
  'may', 'new', 'now', 'old', 'see', 'way', 'day', 'did', 'get', 'let',
  'say', 'she', 'too', 'use', 'end', 'cup', 'set', 'run', 'hit', 'top',
  'big', 'put', 'own', 'try', 'ask', 'men', 'any', 'why', 'few', 'eat',
  'cut', 'yet', 'ago', 'got', 'air', 'war', 'act', 'add', 'pay', 'yes',
  'rain', 'snow', 'will', 'with', 'this', 'that', 'from', 'have', 'been',
  'than', 'them', 'then', 'some', 'make', 'like', 'time', 'very', 'your',
  'just', 'know', 'take', 'come', 'more', 'want', 'give', 'most', 'find',
  'here', 'over', 'such', 'does', 'each', 'much', 'many', 'only', 'also',
  'back', 'game', 'team', 'play', 'last', 'long', 'best', 'even', 'good',
  'same', 'real', 'high', 'keep', 'help', 'turn', 'move', 'live', 'hold',
  'call', 'fall', 'free', 'work', 'part', 'made', 'full', 'near', 'half',
  'open', 'late', 'hard', 'fast', 'left', 'look', 'feel', 'went', 'done',
  'told', 'said', 'name', 'vote', 'rate', 'drop', 'beat', 'lose', 'lost',
  'sold', 'gold', 'deal', 'face', 'pass', 'lead', 'rise', 'cost', 'sign',
  'tomorrow', 'today', 'tonight', 'yesterday', 'monday', 'tuesday', 'wednesday',
  'thursday', 'friday', 'saturday', 'sunday', 'january', 'february', 'march',
  'april', 'june', 'july', 'august', 'september', 'october', 'november', 'december',
  'week', 'month', 'year', 'quarter', 'season', 'before', 'after', 'during', 'until',
  'would', 'which', 'should', 'could', 'there', 'their', 'where',
  'whether', 'through', 'though', 'thought', 'because', 'between', 'enough',
  'receive', 'believe', 'achieve', 'announce', 'available', 'government',
  'what', 'when',
  'bitcoin', 'ethereum', 'cryptocurrency', 'election', 'president', 'presidential',
  'champion', 'championship', 'tournament', 'league', 'playoffs', 'finals',
  'release', 'announcement', 'launch', 'acquisition', 'merger',
  'regulation', 'inflation', 'interest', 'market', 'stock', 'price', 'value',
  'billion', 'million', 'trillion', 'percent', 'percentage', 'probability',
  'super', 'bowl',
  'world', 'olympics', 'premier', 'champions', 'basketball',
  'football', 'soccer', 'baseball', 'tennis', 'formula',
  'weather', 'temperature', 'forecast', 'storm', 'sunny', 'cloudy',
  'artificial', 'intelligence', 'technology', 'microsoft', 'google', 'apple',
  'amazon', 'openai', 'spacex', 'tesla',
  'minister', 'secretary', 'chancellor', 'governor',
  'next', 'first', 'second', 'third', 'above', 'below', 'higher', 'lower',
  'reach', 'break', 'exceed', 'surpass', 'happen', 'become', 'remain',
  'predict', 'prediction', 'outcome', 'result', 'winner', 'champion',
  'quarter', 'annual', 'monthly', 'weekly', 'daily',
  'solana', 'dogecoin', 'cardano', 'polygon', 'avalanche', 'chainlink',
  'congress', 'senate', 'house', 'supreme', 'court', 'federal', 'reserve',
  'debate', 'primary', 'candidate', 'nominee', 'republican', 'democrat',
  'trading', 'exchange', 'liquidity', 'volume', 'revenue', 'profit',
  'company', 'startup', 'funding', 'valuation', 'acquisition',
  'whether', 'before', 'during', 'against', 'between',
  'series', 'match', 'round', 'season', 'player', 'coach', 'transfer',
  'record', 'score', 'points', 'goals', 'medal', 'title', 'trophy',
  'launch', 'release', 'update', 'version', 'feature', 'product',
  'climate', 'hurricane', 'earthquake', 'wildfire', 'drought', 'flood',
];

function levenshtein(a, b) {
  const m = a.length, n = b.length;
  if (m === 0) return n;
  if (n === 0) return m;
  const dp = Array.from({ length: m + 1 }, (_, i) =>
    Array.from({ length: n + 1 }, (_, j) => (i === 0 ? j : j === 0 ? i : 0))
  );
  for (let i = 1; i <= m; i++) {
    for (let j = 1; j <= n; j++) {
      dp[i][j] = a[i - 1] === b[j - 1]
        ? dp[i - 1][j - 1]
        : 1 + Math.min(dp[i - 1][j], dp[i][j - 1], dp[i - 1][j - 1]);
    }
  }
  return dp[m][n];
}

function findSpellingFix(word) {
  const lower = word.toLowerCase();
  if (lower.length < 3) return null;
  if (/^\d+$/.test(lower) || /^[\$€£¥]/.test(lower)) return null;

  let bestMatch = null;
  let bestDist = Infinity;
  let bestLenDiff = Infinity;

  const maxDist = lower.length <= 3 ? 1 : Math.min(2, Math.floor(lower.length / 2));

  for (const known of KNOWN_WORDS) {
    if (Math.abs(known.length - lower.length) > 2) continue;
    if (known.includes(' ')) continue;
    if (known === lower) return null;

    const dist = levenshtein(lower, known);
    if (dist > 0 && dist <= maxDist) {
      const lenDiff = Math.abs(known.length - lower.length);
      if (dist < bestDist || (dist === bestDist && lenDiff < bestLenDiff)) {
        bestDist = dist;
        bestMatch = known;
        bestLenDiff = lenDiff;
      }
    }
  }

  return bestMatch;
}

function getSpellingCorrection(question) {
  const words = question.split(/(\s+)/);
  let hasFix = false;
  const corrected = words.map(segment => {
    if (/^\s+$/.test(segment)) return segment;
    const punctMatch = segment.match(/^([^\w]*)([\w']+)([^\w]*)$/);
    if (!punctMatch) return segment;
    const [, prefix, word, suffix] = punctMatch;
    const fix = findSpellingFix(word);
    if (fix) {
      hasFix = true;
      const cased = word[0] === word[0].toUpperCase()
        ? fix.charAt(0).toUpperCase() + fix.slice(1)
        : fix;
      return prefix + cased + suffix;
    }
    return segment;
  });
  return hasFix ? corrected.join('') : null;
}

export function getDidYouMeanSuggestions(question) {
  const trimmed = question.trim();

  if (trimmed.split(/\s+/).length < 3) return null;

  for (const correction of PHRASING_CORRECTIONS) {
    if (correction.pattern.test(trimmed) && correction.suggestions.length > 0) {
      return {
        type: correction.type || 'correction',
        suggestions: correction.suggestions.slice(0, 3),
      };
    }
  }

  const spellingFix = getSpellingCorrection(trimmed);
  if (spellingFix) {
    return {
      type: 'spelling',
      suggestions: [spellingFix],
    };
  }

  return null;
}
